var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "upgrade" } },
    [
      _c("div", { staticClass: "bg" }),
      _c("c-header-return", {
        attrs: { isCustom: true },
        scopedSlots: _vm._u([
          {
            key: "customTitle",
            fn: function () {
              return [
                _c("div", { staticClass: "flex flex-ver" }, [
                  _c("p", { staticClass: "title-con-middle-title" }, [
                    _vm._v("经典升级"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "title-con-middle flex flex-center-1",
                      on: {
                        click: function ($event) {
                          _vm.notice_modal_show = true
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "case-title-rule-item",
                        attrs: {
                          src: require("../../../assets/images/help_fill.png"),
                        },
                      }),
                      _c("p", [_vm._v("游戏规则")]),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "mall-main-content" }, [
          _c(
            "div",
            { staticClass: "com-tab-block flex flex-ver" },
            [
              _vm._l(
                _vm.assets_data.list_assets_data.categories,
                function (cat, cat_index) {
                  return [
                    cat.id != 99
                      ? _c(
                          "div",
                          {
                            key: cat_index,
                            staticClass: "item flex flex-col flex-center-1",
                            class: {
                              active: cat.id === _vm.assets_data.categoryId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.get_assets_list(
                                  cat.id,
                                  _vm.assets_data.sort_price
                                )
                              },
                            },
                          },
                          [
                            _c("c-picture", {
                              attrs: {
                                src: _vm._f("imgfilter")(cat.imgUrl),
                                width: _vm.$screen.mobile ? "30px" : "50px",
                                height: _vm.$screen.mobile ? "30px" : "50px",
                                ratio: "1:1",
                                size: "contain",
                              },
                            }),
                            _c("p", { staticClass: "text" }, [
                              _vm._v(" " + _vm._s(cat.name)),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }
              ),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mall-filter-con" },
            [
              _c("div", { staticClass: "input" }, [
                _c("form", { attrs: { action: "", "auto-complete": "off" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.assets_data.search_name,
                        expression: "assets_data.search_name",
                      },
                    ],
                    attrs: { type: "text", placeholder: "按名称搜索" },
                    domProps: { value: _vm.assets_data.search_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.assets_data,
                          "search_name",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c("input", {
                    staticStyle: { height: "0", width: "0" },
                    attrs: { type: "text" },
                  }),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/icons/interchange_search_icon.png"),
                    alt: "",
                  },
                }),
              ]),
              _c(
                "Select",
                {
                  on: {
                    "on-change": function ($event) {
                      return _vm.get_assets_list(
                        _vm.assets_data.categoryId,
                        _vm.assets_data.sort_price
                      )
                    },
                  },
                  model: {
                    value: _vm.price_range,
                    callback: function ($$v) {
                      _vm.price_range = $$v
                    },
                    expression: "price_range",
                  },
                },
                [
                  _c("Option", { attrs: { value: 0 } }, [_vm._v("不限")]),
                  _c("Option", { attrs: { value: 1 } }, [_vm._v("0-50")]),
                  _c("Option", { attrs: { value: 2 } }, [_vm._v("50-200")]),
                  _c("Option", { attrs: { value: 3 } }, [_vm._v("200-1000")]),
                  _c("Option", { attrs: { value: 4 } }, [_vm._v("1000-2000")]),
                  _c("Option", { attrs: { value: 5 } }, [_vm._v("2000-10000")]),
                  _c("Option", { attrs: { value: 6 } }, [_vm._v("10000+")]),
                ],
                1
              ),
              _c(
                "div",
                {
                  class: ["sort", _vm.assets_data.sort_price ? "" : "active"],
                  on: {
                    click: function ($event) {
                      return _vm.get_assets_list(
                        _vm.assets_data.categoryId,
                        _vm.assets_data.sort_price
                          ? (_vm.assets_data.sort_price = 0)
                          : (_vm.sort_price = 1)
                      )
                    },
                  },
                },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.assets_data.sort_price
                          ? "↓ 价格从低到高"
                          : "↑ 价格从高到低"
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "mall-item-list" }, [
            _c(
              "ul",
              { staticClass: "list" },
              _vm._l(_vm.active_assets_list, function (item, index) {
                return _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.selected_assets(item)
                      },
                    },
                  },
                  [
                    _c("c-award", {
                      staticClass: "award",
                      attrs: {
                        rarity: item.rarity,
                        picture: item.imgUrl,
                        name: item.name,
                        price: item.price,
                        width: "100%",
                      },
                    }),
                    _c("div", { staticClass: "item-footer" }, [
                      _c(
                        "div",
                        { staticClass: "price" },
                        [
                          _c("span", { staticClass: "val" }, [
                            _vm._v(" " + _vm._s(item.price) + " "),
                            _vm.isHappyCoin
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "happy-b",
                                    staticStyle: {
                                      "font-size": "12px",
                                      "margin-left": "2px",
                                    },
                                  },
                                  [_vm._v(" 欢乐豆 ")]
                                )
                              : _vm._e(),
                          ]),
                          _c("c-svg", {
                            attrs: {
                              src: "bill.svg",
                              width: "12",
                              height: "12",
                              fill: "#4762f2",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "经典升级玩法说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(
                    " 1、您会随机获得一件饰品，或有机会获得一件心仪的饰品。※总成功率不得低于 5%。 "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " 2、每次成功概率为相互独立的，例如 30% 的成功概率升级 3 次，但不代表有 90% 的机会。 "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }